export const handleSearchParams = (param, value) => {
  const search = new URLSearchParams(window.location.search);
  !value || value === undefined || value === '' || value === 'null' ? search.delete(param) : search.set(param, value);
  // `replaceState`, no `pushState`: los informes escriben un parámetro por
  // llamada (quince por consulta) y con pushState el botón Atrás del
  // navegador no salía nunca de la página. La URL sigue siendo compartible.
  window.history.replaceState({}, '', `${window.location.pathname}?${search.toString()}`);
};

export const getSearchParams = (param) => {
  const search = new URLSearchParams(window.location.search);
  return search.get(param);
};
